import { render, staticRenderFns } from "./FormDataValid.vue?vue&type=template&id=e4bfb564&scoped=true"
import script from "./FormDataValid.vue?vue&type=script&lang=js"
export * from "./FormDataValid.vue?vue&type=script&lang=js"
import style0 from "./FormDataValid.vue?vue&type=style&index=0&id=e4bfb564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bfb564",
  null
  
)

export default component.exports